import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksCheckInput, {
  InputType,
} from '../../../../components/books/model1/forms/BooksCheckInput';
import BooksPaymentCard from '../../../../components/books/model1/forms/BooksPaymentCard';
import { CardSelection } from '../../../../interfaces/merchants/resources/books';
import { Me } from '../../../../interfaces/users';

import css from './InputPaymentMyCreditCard.module.scss';

interface Props {
  me: Me;
  onSelect: (cardSelection: CardSelection) => void;
  mySelection?: CardSelection;
}

class InputPaymentMyCreditCard extends React.Component<
  Props & InjectedIntlProps
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  private handleSelect(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { value },
    } = e;
    const mySelection = value as CardSelection;
    this.props.onSelect(mySelection);
  }

  public render() {
    const { intl, me, mySelection } = this.props;

    if (!me.creditCard) {
      // クレジットカードの履歴がない場合は表示する必要なし
      return null;
    }

    return (
      <li className={css.InputPaymentMyCreditCard}>
        <BooksPaymentCard
          className={css.InputPaymentMyCreditCard__Item}
          tailDigits={me.creditCard.tailDigits}
          value={CardSelection.Used}
          checked={mySelection === CardSelection.Used}
          onChange={this.handleSelect}
        />
        <BooksCheckInput
          className={css.InputPaymentMyCreditCard__Item}
          type={InputType.Radio}
          value={CardSelection.Another}
          checked={mySelection === CardSelection.Another}
          onChange={this.handleSelect}
          name="payment-creditcard"
        >
          {intl.formatMessage({ id: 'books.forms.addNewCreditCard' })}
        </BooksCheckInput>
      </li>
    );
  }
}

export default injectIntl(InputPaymentMyCreditCard);
